import React from 'react';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { getSimpleDateFormat } from 'utils/functions';
import { OrderType } from 'models/order.model';

type Props = {
  order: OrderType;
};

const CardFooter = ({ order }: Props) => {
  const dateObj = new Date(order.created_at);
  const time = dateObj.toLocaleString('en-NG', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  return (
    <div className='border-t border-gray-border text-xs p-4 flex justify-between items-center'>
      <div className='flex items-center gap-2'>
        <ClockIcon />
        <div className='flex items-center gap-2'>
          {getSimpleDateFormat(order.created_at)}
          <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
          {time}
        </div>
      </div>
      <p className='underline text-red-4'>View details</p>
    </div>
  );
};

export default CardFooter;
